/* Homepage: load the reverse photo only when the visitor inspects a card. */
(() => {
  const reveal = (event) => {
    if (event.type === 'pointerover' &&
        (event.pointerType === 'touch' || !matchMedia('(any-hover: hover)').matches)) return;
    const holder = event.target.closest?.('.product-holder');
    const card = holder?.querySelector('[data-js-product-item]');
    const template = card?.querySelector('template[data-amana-secondary]');
    if (!template || template.dataset.loading) return;
    template.dataset.loading = 'true';
    const fragment = template.content.cloneNode(true);
    const image = fragment.querySelector('img');
    if (!image) return;
    const ready = () => {
      if (!image.naturalWidth) return;
      card.classList.add('with-secondary-image');
      card.classList.remove('with-deferred-secondary-image');
      template.remove();
    };
    image.addEventListener('load', ready, { once: true });
    image.loading = 'eager';
    template.parentElement.append(fragment);
    if (image.complete) ready();
  };
  document.addEventListener('pointerover', reveal, { passive: true });
  document.addEventListener('focusin', reveal);
})();
